const files = [
  {
    name: "FIN_Autofin.xlsx",
    route: "couverture-autofinancee",
    label: "Couverture autofinancée",
    frequency: "monthly",
  },
  {
    name: "FIN_Bclmt.xlsx",
    route: "bouclement-annuel",
    label: "Bouclement annuel",
    frequency: "yearly",
  },
  {
    name: "FIN_Cat_projet_Tx_FG.xlsx",
    route: "categorie-projets",
    label: "Catégorie projets",
    frequency: "yearly",
  },
  {
    name: "FIN_Contrib_HES.xlsx",
    route: "contribution-hes",
    label: "Contribution HES",
    frequency: "yearly",
  },
  {
    name: "FIN_Instituts.xlsx",
    route: "instituts",
    label: "Instituts",
    frequency: "yearly",
  },
  {
    name: "FIN_Prov_Institut.xlsx",
    route: "provision-institut",
    label: "Provision institut",
    frequency: "monthly",
  },
  {
    name: "FIN_Salaires_FeE.xlsx",
    route: "salaires",
    label: "Salaires FeE",
    frequency: "monthly",
  },
  {
    name: "FIN_Socle_dispo.xlsx",
    route: "socle-disponible",
    label: "Socle disponible",
    frequency: "monthly",
  },
  {
    name: "FIN_Statut_Projet.xlsx",
    route: "statut-projet",
    label: "Statut projet",
    frequency: "yearly",
  },
  {
    name: "FIN_TABI_Risques_Projets.xlsx",
    route: "risques-projets",
    label: "Risques projets",
    frequency: "monthly",
  },
];

export default files;
